import React from 'react';
import { useTranslation } from 'react-i18next';
import { useEquipoEstadisticasById } from '../../hooks/queries/useEquipoEstadisticas';
import { useCompeticionByIdTemporadaAndId } from '../../hooks/queries/useCompeticiones';
import { playerParticipationRates, playerTeamStatisticsId } from '../../utils/playerStatistics';

const RATE_KEYS = ['minutesPerAppearance', 'startCallupPercent', 'appearanceCallupPercent',
  'callupTeamPercent', 'minutesTeamPercent'];

export function ParticipationRateTable({ player, team, competition, loading = false, error = false, retry }) {
  const { t, i18n } = useTranslation('players');
  const scopes = ['total', 'local', 'visitante'].map(scope => playerParticipationRates(player, team, competition, scope));
  const format = value => value === null ? '—' : value.toLocaleString(i18n.language, { maximumFractionDigits: 2 });
  return <div className="ps-rates">
    <h3>{t('modern.rates.title')}</h3>
    <div className="ps-table-scroll" tabIndex={0} role="region" aria-label={t('modern.rates.title')}>
      <table className="ps-table" aria-label={t('modern.rates.title')}>
        <thead><tr>{['metric', 'total', 'home', 'away'].map(key =>
          <th key={key} scope="col">{t(`modern.${key}`)}</th>)}</tr></thead>
        <tbody>{RATE_KEYS.map(key => <tr key={key}><th scope="row">{t(`modern.rates.${key}`)}</th>
          {scopes.map((rates, index) => <td key={index}>{format(rates[key])}
            {rates[key] !== null && key !== 'minutesPerAppearance' ? '%' : ''}</td>)}
        </tr>)}</tbody>
      </table>
    </div>
    <p className="ps-note">{t('modern.rates.method')}</p>
    {scopes[0].teamMatches !== null && <p className="ps-note">{t('modern.rates.teamSample', {
      count: scopes[0].teamMatches,
    })}{scopes[0].duration > 0 && ` · ${t('modern.rates.duration', { minutes: scopes[0].duration })}`}</p>}
    {loading && <p className="ps-note" role="status">{t('modern.rates.loading')}</p>}
    {error && <p className="ps-note" role="status">{t('modern.rates.error')} <button type="button"
      className="ps-rates-retry" onClick={retry}>{t('errors.retry')}</button></p>}
  </div>;
}

function ParticipationWithContext({ player }) {
  const team = useEquipoEstadisticasById(player.idTemporada, playerTeamStatisticsId(player));
  const competition = useCompeticionByIdTemporadaAndId(player.idTemporada, player.idCompeticion);
  return <ParticipationRateTable player={player} team={team.data} competition={competition.data?.competition}
    loading={team.isLoading || competition.isLoading} error={team.isError || competition.isError}
    retry={() => { team.refetch(); competition.refetch(); }} />;
}

export default function PlayerParticipationRates({ player }) {
  return playerTeamStatisticsId(player) ? <ParticipationWithContext player={player} />
    : <ParticipationRateTable player={player} />;
}
